import { render, staticRenderFns } from "./style-select-popper.vue?vue&type=template&id=b22e5534&scoped=true&"
import script from "./style-select-popper.vue?vue&type=script&lang=js&"
export * from "./style-select-popper.vue?vue&type=script&lang=js&"
import style0 from "./style-select-popper.vue?vue&type=style&index=0&id=b22e5534&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b22e5534",
  null
  
)

export default component.exports